function Get_Email_Template(
  Str_Template,
  Arr_Emails,
  Str_Student_Name,
  Str_SEFLink,
  Str_CUSTOMTEXT
) {
  const Arr_EmailTemplates = [
    {
      Template: "Phone Number Repeat",
      IntroText: "None",
      Email_Array: Arr_Emails,
      Subject_Line: "Important, student information required",
      BODY_TEXT_1: "Dear parent/ guardian of " + Str_Student_Name + ",",
      BODY_TEXT_2:
        "Thank you for completing your child’s enrolment form for their summer experience with InvestIN. We have reviewed the information provided and noticed we do not have an individual phone number for your child. We ask all attending students to provide their own phone number, so we have a way to contact them if needed.",
      BODY_TEXT_3:
        "Kindly use this link to return to the form to provide the additional information needed. Please ensure this is completed at least four weeks before the start date.",
      BODY_TEXT_4: Str_SEFLink,
      BODY_TEXT_5:
        "If you have any questions about this, please email dsl@investin.org",
      BODY_TEXT_6: "Thank you, InvestIN Team",
      BODY_TEXT_7: "",
      BODY_TEXT_8: "",
      BODY_TEXT_9: "",
      BODY_TEXT_10: "",
    },
    {
      Template: "Photo Incorrect",
      IntroText: "None",
      Email_Array: Arr_Emails,
      Subject_Line: "Important, student information required",
      BODY_TEXT_1: "Dear parent/ guardian of " + Str_Student_Name + ",",
      BODY_TEXT_2:
        "Thank you for completing your child’s enrolment form for their summer experience with InvestIN. We have reviewed the information provided and noticed the photograph/ ID does not meet the requirements, please ensure:",
      BODY_TEXT_3: "",
      BODY_TEXT_4:
        "--	The photograph uploaded is a clear, face on passport/ portrait style and has been taken within the last 6 months",
      BODY_TEXT_5:
        "--	The ID image includes the students photograph, date of birth and full name",
      BODY_TEXT_6:
        "•	Please note, some forms of ID (such as a British Biometric Resident Card) show the date of birth on the back of the card, ensure you upload a scan of both sides if needed",
      BODY_TEXT_7:
        "Kindly use the below link to return to the form to provide the additional information needed. Unfortunately, without this we cannot progress their enrolment. Please ensure this is completed within 7 working days, we look forward to welcoming your child in the summer!",
      BODY_TEXT_8: Str_SEFLink,
      BODY_TEXT_9:
        "If you have any questions about this, please email dsl@investin.org, Thank you, InvestIN Team",
      BODY_TEXT_10: "",
    },
    {
      Template: "Language Cert Missing",
      IntroText: "None",
      Email_Array: Arr_Emails,
      Subject_Line: "Important, student information required",
      BODY_TEXT_1: "Dear parent/ guardian of " + Str_Student_Name + ",",
      BODY_TEXT_2:
        "Thank you for completing your child’s enrolment form for their summer experience with InvestIN. We have reviewed the information provided and noticed that their language certificate is missing.",
      BODY_TEXT_3: "",
      BODY_TEXT_4:
        "Kindly use the link below to return to the form to provide the additional information needed. Unfortunately, without this we cannot progress their enrolment. Please ensure this is completed within 7 working days, we look forward to welcoming your child in the summer!",
      BODY_TEXT_5: Str_SEFLink,
      BODY_TEXT_6:
        "If you have any questions about this, please email dsl@investin.org",
      BODY_TEXT_7: "Thank you, InvestIN team",
      BODY_TEXT_8: "",
      BODY_TEXT_9: "",
      BODY_TEXT_10: "",
    },
    {
      Template: "General Contact Details",
      IntroText:
        "We have reviewed the information provided and noticed a discrepancy in the contact/ general information on...",
      Email_Array: Arr_Emails,
      Subject_Line: "Important, student information required",
      BODY_TEXT_1: "Dear parent/ guardian of " + Str_Student_Name + ",",
      BODY_TEXT_2:
        "Thank you for completing your child’s enrolment form for their summer experience with InvestIN. We have reviewed the information provided " +
        Str_CUSTOMTEXT,
      BODY_TEXT_3:
        "Kindly use the link below to return to the form to provide the additional information needed. Unfortunately, without this we cannot progress their enrolment. Please ensure this is completed within 7 working days, we look forward to welcoming your child in the summer!",
      BODY_TEXT_4: Str_SEFLink,
      BODY_TEXT_5:
        "If you have any questions about this, please email dsl@investin.org",
      BODY_TEXT_6: "Thank you, InvestIN team",
      BODY_TEXT_7: "",
      BODY_TEXT_8: "",
      BODY_TEXT_9: "",
      BODY_TEXT_10: "",
    },
    {
      Template: "Misc Other",
      IntroText: "We have reviewed the information provided and noticed...",
      Email_Array: Arr_Emails,
      Subject_Line: "Important, student information required",
      BODY_TEXT_1: "Dear parent/ guardian of " + Str_Student_Name + ",",
      BODY_TEXT_2:
        "Thank you for completing your child’s enrolment form for their summer experience with InvestIN. We have reviewed the information provided and noticed " +
        Str_CUSTOMTEXT,
      BODY_TEXT_3:
        "Kindly use the link below to return to the form to provide the additional information needed. Unfortunately, without this we cannot progress their enrolment. Please ensure this is completed within 7 working days, we look forward to welcoming your child in the summer!",
      BODY_TEXT_4: Str_SEFLink,
      BODY_TEXT_5:
        "If you have any questions about this, please email dsl@investin.org",
      BODY_TEXT_6: "Thank you, InvestIN team",
      BODY_TEXT_7: "",
      BODY_TEXT_8: "",
      BODY_TEXT_9: "",
      BODY_TEXT_10: "",
    },
    {
      Template: "Address Required",
      IntroText: "None",
      Email_Array: Arr_Emails,
      Subject_Line: "Important, student information required",
      BODY_TEXT_1: "Dear parent/ guardian of " + Str_Student_Name + ",",
      BODY_TEXT_2:
        "Thank you for completing your child’s enrolment form for their summer experience with InvestIN. We have reviewed the information provided and noticed you have not provided an address for your child during their time on the summer experience. It is important that we have a correct address for all students attending out programmes in the event of an emergency.",
      BODY_TEXT_3:
        "Kindly use this link to return to the form to provide the additional information needed. Please ensure this is completed at least four weeks before the start date.",
      BODY_TEXT_4: Str_SEFLink,
      BODY_TEXT_5:
        "If you have any questions about this, please email dsl@investin.org",
      BODY_TEXT_6: "Thank you, InvestIN team",
      BODY_TEXT_7: "",
      BODY_TEXT_8: "",
      BODY_TEXT_9: "",
      BODY_TEXT_10: "",
    },
    {
      Template: "Medication Info",
      IntroText:
        "Thank you for completing your child’s enrolment form for their summer experience with InvestIN. We have reviewed the information provided and require further information about their medication.",
      Email_Array: Arr_Emails,
      Subject_Line: "Important, student information required",
      BODY_TEXT_1: "Dear parent/ guardian of " + Str_Student_Name + ",",
      BODY_TEXT_2:
        "Thank you for completing your child’s enrolment form for their summer experience with InvestIN. We have reviewed the information provided and require further information about their medication.",
      BODY_TEXT_3: Str_CUSTOMTEXT,
      BODY_TEXT_4: Str_SEFLink,
      BODY_TEXT_5:
        "Kindly use the link above to return to the form to provide the additional information needed. Unfortunately, without this we cannot progress their enrolment. Please ensure this is completed within 7 working days, we look forward to welcoming your child in the summer!",
      BODY_TEXT_6:
        "If you have any questions about this, please email dsl@investin.org",
      BODY_TEXT_7: "Thank you, InvestIN team",
      BODY_TEXT_8: "",
      BODY_TEXT_9: "",
      BODY_TEXT_10: "",
    },
    {
      Template: "Mental Health Concerns",
      IntroText: "None",
      Email_Array: Arr_Emails,
      Subject_Line: "Important, student information required",
      BODY_TEXT_1: "Dear parent/ guardian of " + Str_Student_Name + ",",
      BODY_TEXT_2:
        "Thank you for completing your child’s enrolment form for their summer experience with InvestIN. We have reviewed the information provided and noticed that you have indicated your child may require additional support with their emotional wellbeing during their time with us. It would be really helpful to arrange a call with you to discuss their needs and how best we can support them.",
      BODY_TEXT_3: "",
      BODY_TEXT_4: "",
      BODY_TEXT_5:
        "Please email dsl@investin.org to arrange a time to discuss this.",
      BODY_TEXT_6: "Thank you, InvestIN team",
      BODY_TEXT_7: "",
      BODY_TEXT_8: "",
      BODY_TEXT_9: "",
      BODY_TEXT_10: "",
    },
    {
      Template: "Physical Health Concerns",
      IntroText: "None",
      Email_Array: Arr_Emails,
      Subject_Line: "Important, student information required",
      BODY_TEXT_1: "Dear parent/ guardian of " + Str_Student_Name + ",",
      BODY_TEXT_2:
        "Thank you for completing your child’s enrolment form for their summer experience with InvestIN. We have reviewed the information provided and noticed that you have indicated your child may require additional support during their time with us. It would be helpful to arrange a call with you to discuss their needs and how best we can support them.",
      BODY_TEXT_3: "",
      BODY_TEXT_4: "",
      BODY_TEXT_5:
        "Please email dsl@investin.org to arrange a time to discuss this.",
      BODY_TEXT_6: "Thank you, InvestIN team",
      BODY_TEXT_7: "",
      BODY_TEXT_8: "",
      BODY_TEXT_9: "",
      BODY_TEXT_10: "",
    },
    {
      Template: "Disability Mobility Support",
      IntroText:
        "We have reviewed the information provided and noticed that they may require some additional support regarding their physical health as noted on...",
      Email_Array: Arr_Emails,
      Subject_Line: "Important, student information required",
      BODY_TEXT_1: "Dear parent/ guardian of " + Str_Student_Name + ",",
      BODY_TEXT_2:
        "Thank you for completing your child’s enrolment form for their summer experience with InvestIN. We have reviewed the information provided and noticed that they may require some additional support regarding their physical health as noted on " +
        Str_CUSTOMTEXT,
      BODY_TEXT_3:
        "It would be helpful to arrange a call with you to discuss their needs and how best we can support them.",
      BODY_TEXT_4: "",
      BODY_TEXT_5:
        "Please email dsl@investin.org to arrange a time to discuss this.",
      BODY_TEXT_6: "Thank you, InvestIN team",
      BODY_TEXT_7: "",
      BODY_TEXT_8: "",
      BODY_TEXT_9: "",
      BODY_TEXT_10: "",
    },
    {
      Template: "SEND Support",
      IntroText: "None",
      Email_Array: Arr_Emails,
      Subject_Line: "Important, student information required",
      BODY_TEXT_1: "Dear parent/ guardian of " + Str_Student_Name + ",",
      BODY_TEXT_2:
        "Thank you for completing your child’s enrolment form for their summer experience with InvestIN. We have reviewed the information provided and noticed that you have indicated your child may require additional SEND support during their time with us. It would be helpful to arrange a call with you to discuss their needs and how best we can support them.",
      BODY_TEXT_3: "",
      BODY_TEXT_4: "",
      BODY_TEXT_5:
        "Please email dsl@investin.org to arrange a time to discuss this.",
      BODY_TEXT_6: "Thank you, InvestIN team",
      BODY_TEXT_7: "",
      BODY_TEXT_8: "",
      BODY_TEXT_9: "",
      BODY_TEXT_10: "",
    },
    {
      Template: "Assign Helen",
      IntroText: "Please see SEF- review section:",
      Email_Array: Arr_Emails,
      Subject_Line: "SEF Assignment",
      BODY_TEXT_1: "Helen,",
      BODY_TEXT_2: "Please see SEF- review section:",
      BODY_TEXT_3: Str_CUSTOMTEXT,
      BODY_TEXT_4: "",
      BODY_TEXT_5: "",
      BODY_TEXT_6: "",
      BODY_TEXT_7: "",
      BODY_TEXT_8: "",
      BODY_TEXT_9: "",
      BODY_TEXT_10: "",
    },
    {
      Template: "Assign Hannah",
      IntroText: "Please see SEF- review section:",
      Email_Array: Arr_Emails,
      Subject_Line: "SEF Assignment",
      BODY_TEXT_1: "Hannah,",
      BODY_TEXT_2: "Please see SEF- review section:",
      BODY_TEXT_3: Str_CUSTOMTEXT,
      BODY_TEXT_4: "",
      BODY_TEXT_5: "",
      BODY_TEXT_6: "",
      BODY_TEXT_7: "",
      BODY_TEXT_8: "",
      BODY_TEXT_9: "",
      BODY_TEXT_10: "",
    },
    {
      Template: "Admin Updates",
      IntroText: "Admin Updates:",
      Email_Array: Arr_Emails,
      Subject_Line: "SEF Assignment",
      BODY_TEXT_1: "Hey,",
      BODY_TEXT_2: "You just marked an attendee as Admin Updates,",
      BODY_TEXT_3: Str_CUSTOMTEXT,
      BODY_TEXT_4: "",
      BODY_TEXT_5: "",
      BODY_TEXT_6: "",
      BODY_TEXT_7: "",
      BODY_TEXT_8: "",
      BODY_TEXT_9: "",
      BODY_TEXT_10: "",
    },
    {
      Template: "Parent Callback Requested",
      IntroText: "Parent Callback Requested:",
      Email_Array: Arr_Emails,
      Subject_Line: "SEF Assignment",
      BODY_TEXT_1: "Hey,",
      BODY_TEXT_2: "You just marked an attendee as Parent Callback Requested,",
      BODY_TEXT_3: Str_CUSTOMTEXT,
      BODY_TEXT_4: "",
      BODY_TEXT_5: "",
      BODY_TEXT_6: "",
      BODY_TEXT_7: "",
      BODY_TEXT_8: "",
      BODY_TEXT_9: "",
      BODY_TEXT_10: "",
    },
    {
      Template: "SPARE",
      IntroText: "None",
      Email_Array: Arr_Emails,
      Subject_Line: "Important, student information required",
      BODY_TEXT_1: "Dear parent/ guardian of " + Str_Student_Name + ",",
      BODY_TEXT_2: "XXXXX",
      BODY_TEXT_3: "XXXXX",
      BODY_TEXT_4: "XXXXX",
      BODY_TEXT_5: "XXXXX",
      BODY_TEXT_6: "XXXXX",
      BODY_TEXT_7: "XXXXX",
      BODY_TEXT_8: "XXXXX",
      BODY_TEXT_9: "XXXXX",
      BODY_TEXT_10: "XXXXX",
    },
  ];

  let Email_Template = Arr_EmailTemplates.find(
    (One) => One.Template === Str_Template
  );

  if (Email_Template) {
    return Email_Template;
  } else {
    return {};
  }
}

module.exports = Get_Email_Template;
